// src/sections/ServiziSocial.jsx
import React from "react";

const ServiziSocial = ({ contenuti }) => {
  // 1) Oggetto → array
  const items = Array.isArray(contenuti) ? contenuti : Object.values(contenuti);

  // 2) Intro: l’elemento che NON comincia con App né con Social
  const serviziIntro = items.find(
    (c) => !c.titolo_it.startsWith("App") && !c.titolo_it.startsWith("Social")
  );

  // 3) App e figli
  const appParent = items.find((c) => c.titolo_it === "App");
  const appChildren = items.filter((c) => c.titolo_it.startsWith("App->"));

  // 4) Social e figli
  const socialParent = items.find((c) => c.titolo_it === "Social");
  const socialChildren = items.filter((c) => c.titolo_it.startsWith("Social->"));

  // 5) Split del titolo di introduzione, con classi diverse
  let introTitleLines = [];
  if (serviziIntro?.titolo_it) {
    introTitleLines = serviziIntro.titolo_it
      .split("|")
      .map((s) => s.trim());
  }

  // Helper per decidere quale link usare (iOS | Android/Desktop)
  const getStoreLink = (rawLink) => {
    let iosLink = rawLink;
    let androidLink = rawLink;

    // se c'è una pipe, splitta e trimma
    if (rawLink.includes("|")) {
      const [first, second] = rawLink.split("|");
      iosLink = first.trim();
      androidLink = second.trim();
    }

    const ua = navigator.userAgent || "";
    const isAndroid = /Android/.test(ua);
    const isIOS =
      /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

    if (isIOS) return iosLink;
    // Android + Desktop → Play Store
    return androidLink;
  };

  return (
    <section
      className="bg-dark-green position-relative text-21"
      style={{ padding: "76px 16px" }}
    >
      <div className="position-absolute w-100 head-onda reverse">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 50"
          preserveAspectRatio="none"
          className="w-100"
        >
          <path
            fill="#fff"
            d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50C320,50,160,50,80,50L0,50Z"
          ></path>
        </svg>
      </div>
      <div className="container text-white py-5">
        {/* --- RIGA INTRODUZIONE --- */}
        {serviziIntro && (
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h2 className="title-section">
                {introTitleLines.map((line, i) => (
                  <span
                    key={i}
                    className={i === 0 ? "" : "ms-3 light-green"}
                  >
                    {line}
                  </span>
                ))}
              </h2>
              {serviziIntro.descrizione_it && (
                <p
                  className="mt-3"
                  dangerouslySetInnerHTML={{
                    __html: serviziIntro.descrizione_it,
                  }}
                />
              )}
            </div>
          </div>
        )}

        {/* --- RIGA PRINCIPALE: App / Social --- */}
        <div className="row">
          {/* COLONNA SINISTRA: App */}
          <div className="col-12 col-sm-6">
            {appParent?.descrizione_it && (
              <p
                className="mb-5 light-green"
                dangerouslySetInnerHTML={{
                  __html: appParent.descrizione_it,
                }}
              />
            )}
            <div className="d-flex flex-column">
              {appChildren.map((child) => {
                const href = getStoreLink(child.link_it);
                return (
                  <div
                    key={child.ID}
                    className="d-flex align-items-center"
                    style={{ marginBottom: "32px" }}
                  >
                    <a
                      className="d-flex flex-row"
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {child.immagine_url && (
                        <img
                          src={child.immagine_url}
                          alt={child.titolo_it}
                          className="me-3 icon-page"
                        />
                      )}
                      {child.descrizione_it && (
                        <p className="mb-0 text-white">
                          {child.descrizione_it}
                        </p>
                      )}
                    </a>
                  </div>
                );
              })}
            </div>
          </div>

          {/* COLONNA DESTRA: Social */}
          <div className="col-12 col-sm-6">
            {socialParent?.descrizione_it && (
              <p
                className="mb-5 light-green"
                dangerouslySetInnerHTML={{
                  __html: socialParent.descrizione_it,
                }}
              />
            )}
            <div className="d-flex flex-column">
              {socialChildren.map((child) => (
                <div
                  key={child.ID}
                  className="d-flex align-items-center"
                  style={{ marginBottom: "32px" }}
                >
                  <a
                    className="d-flex flex-row"
                    href={child.link_it}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {child.immagine_url && (
                      <img
                        src={child.immagine_url}
                        alt={child.titolo_it}
                        className="me-3 icon-page"
                      />
                    )}
                    {child.descrizione_it && (
                      <p className="mb-0 text-white">
                        {child.descrizione_it}
                      </p>
                    )}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiziSocial;
